var pluralize = require('pluralize');

const utl = {
	methods:{

		// Page stuff

		generateUuid(){
			return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
				(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
			  );
		},

		generateLid(){
			return 'LID'+this.generateUuid();
		},

		setPageTitle(title){
			setTimeout(function(){
				document.title = title + TITLE_END;
			},20);
		},

		// Text stuff
		
		dsplDate(mysql_string){
			var d = moment.utc(mysql_string);
			var since = moment.duration(moment().diff(d));
			var hours_since = since.asHours();
			if(hours_since < 24){
				return d.fromNow();
			} else {
				return d.format('DD/MM/YY');
			}
		},
		dsplPrice(pence,free_text=false){
			if(pence === 0 || pence === '0') return free_text ? 'FREE' : '£0';
			if(!pence) return 'QR';
			return '£' + ((Math.round(pence)/100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")).replace('.00','');
		},
		dsplSpeed(s){
			var gig = (s/1000)>=1;
			return (((gig)?s/1000:s)+'').replace(/\B(?=(\d{3})+(?!\d))/g, ",")+''+(gig?'Gbps':'Mbps');
		},
		dsplSnakeCase(s){
			return this.ucFirst(s.split('_').join(' '));
		},
		dsplPlural(s,count){
			return count==1?s:pluralize(s);
		},
		dsplApostrophize(str){
			return str.slice(-1)=='s' ? str+"'" : str+"'s";
		},

		// Text manipulation

		ucFirst(s){
			return s.charAt(0).toUpperCase() + s.slice(1);
		},

		titleCase(s){
			return s.split(' ').map(w=>this.ucFirst(w)).join(' ');
		},

		// Tools
		

		publicUrl(stub = ''){
			return window.publicBaseUrl + stub;
		},

	}
};

export default utl;